import { css } from '@utils/css';

const heading = css`
  margin: 0;
  font-weight: inherit;
`;
const paragraph = css`
  margin: 0;
`;

export { heading, paragraph };
//# sourceMappingURL=text.js.map
